import {Injectable} from "@angular/core";
import {AbstractFindOneByIdService} from "../../../../../core/service/v2/service/findone/abstractFindOneById.service";
import {FormDefinitionFormModel} from "../../api/entity/formDefinitionForm.model";
import {FormDefinitionFormRepository} from "./ngrx/formDefinitionForm.repository";
import {FormDefinitionFormDataServiceAdapter} from "./ngrx/formDefinitionFormDataService.adapter";

@Injectable()
export class FormDefinitionFormFindOneByIdService extends AbstractFindOneByIdService<FormDefinitionFormModel, FormDefinitionFormModel> {

    constructor(repository: FormDefinitionFormRepository, dataServiceAdapter: FormDefinitionFormDataServiceAdapter) {
        super(repository, dataServiceAdapter);
    }
}